import { get } from 'axios';

export const getExtras = async bookingRef => {
  const { data } = await get(`/api/package/${bookingRef}/extras`);

  return {
    bookingRef,
    extras: data.extras,
  };
};

export const getExtrasAvailability = async bookingRef => {
  const { data } = await get(`/api/package/${bookingRef}/extrasavailability`);
  return {
    bookingRef,
    availability: data.extras,
  };
};

export const getExtraAvailability = async (bookingRef, extraId) => {
  const { data } = await get(
    `/api/package/${bookingRef}/extra/${extraId}/availability`,
  );

  return {
    bookingRef,
    availability: data.extras,
  };
};

export const getAccommodationExtras = async (bookingRef, accommodationId) => {
  try {
    const { data } = await get(
      `/api/package/${bookingRef}/accommodation/${accommodationId}/extras`,
    );

    if (!data) {
      throw new Error('Response data is undefined');
    }

    return {
      bookingRef,
      accommodationExtras: data.accommodationExtras,
    };
  } catch (error) {
    return {
      bookingRef,
      errors: error.response?.data || { message: error.message },
    };
  }
};
